import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { SessionProvider } from './auth/SessionProvider';
import { queryClient } from './lib/data';
import { registerServiceWorker } from './lib/push';
import { DrawerProvider, ToastProvider } from './ui/kit';
import './index.css';
import './styles/prototype.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

registerServiceWorker();

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <SessionProvider>
          <ToastProvider>
            <DrawerProvider>
              <App />
            </DrawerProvider>
          </ToastProvider>
        </SessionProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
